<template>
  <ActionButton
    class="manifest-action-button"
    :actions-by-status="actionsByStatus"
    :status="manifest?.data?.status"
    :loading="manifest?.loading"
  />
</template>

<script lang="ts" setup>
import { computed, Ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { Loadable, RygenMenuItem } from '@rygen/rygen-ui/model';

import { Manifest, ManifestStatus } from '@/model';

import ActionButton from '@rygen/rygen-ui/components/button/ActionButton.vue';

const manifest = defineModel<Loadable<Manifest>>();
const emit = defineEmits<{
  (event: 'print'): void;
  (event: 'cancel'): void;
}>();

const { t } = useI18n();

const hasDocument = computed(() => manifest.value?.data?.hasDocument ?? false);

const printAction: Ref<RygenMenuItem> = computed(() => ({
  key: 'PRINT',
  label: t('common.printParam', { param: t('manifests.manifests') }),
  icon: 'pi pi-print',
  disabled: !hasDocument.value,
  command: () => emit('print'),
}));

const cancelAction = computed<RygenMenuItem>(() => ({
  key: 'CANCEL',
  label: t('common.cancelParam', { param: t('manifests.manifests') }),
  icon: 'pi pi-times',
  requiredAuthorization: ['shipment', 'update'],
  command: () => emit('cancel'),
}));

const actionsByStatus = computed<{
  [key in ManifestStatus]: RygenMenuItem[];
}>(() => ({
  [ManifestStatus.MANIFESTED]: [printAction.value, cancelAction.value],
  [ManifestStatus.CANCELED]: [printAction.value],
  [ManifestStatus.FAILED]: [printAction.value],
}));
</script>
